import { useAuthStore } from '@/store/authStore';

/**
 * Wraps a protected feature. When the user is not signed in, renders a
 * prompt to sign in instead of the children. Use this around individual
 * tabs/panels that require auth — not around the whole app.
 */
export function LoginGate({ children, feature = 'this feature' }: {
  children: React.ReactNode;
  feature?: string;
}) {
  const token = useAuthStore((s) => s.token);

  if (!token) {
    return (
      <div style={{
        height: '100%', width: '100%', background: '#0a0e14',
        display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center',
        fontFamily: '"JetBrains Mono", monospace',
      }}>
        <div style={{
          background: '#161b22', border: '1px solid #30363d',
          borderRadius: 12, padding: '40px 48px',
          display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 20,
          maxWidth: 380, width: '100%',
        }}>
          <div style={{ color: '#e6edf3', fontSize: 15, fontWeight: 600 }}>
            Sign in to use {feature}
          </div>
          <div style={{ color: '#8b949e', fontSize: 12, textAlign: 'center' }}>
            Create a free account to unlock monitoring, alerts, and per-domain preferences.
          </div>
          <a
            href="/api/auth/oauth/login"
            style={{
              display: 'flex', alignItems: 'center', gap: 10,
              background: '#1f6feb', color: '#fff',
              border: 'none', borderRadius: 8,
              padding: '10px 24px', cursor: 'pointer',
              fontSize: 13, fontFamily: '"JetBrains Mono", monospace',
              textDecoration: 'none', fontWeight: 600,
              width: '100%', justifyContent: 'center',
            }}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M12 2L2 7l10 5 10-5-10-5z"/>
              <path d="M2 17l10 5 10-5"/>
              <path d="M2 12l10 5 10-5"/>
            </svg>
            Sign in with AfterDark
          </a>
          <div style={{ color: '#6e7681', fontSize: 11 }}>
            Powered by AfterDark Systems identity
          </div>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
